<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('letrex.list.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('letrex.list.title') }}
        </h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-letrex-new' }"
        >
          {{ $t('letrex.list.add') }}
        </router-link>
      </div>
    </d-row>

    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">{{ $t('letrex.table.title') }}</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    :placeholder="$t('letrex.table.searchPlaceholder')"
                    :aria-label="$t('shared.actions.search')"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <puzzle-list-table
                :puzzles="puzzle.list"
                eventName="Delete:Letrex"
                :sendable="true"
                @sendBatch="handleSendBatch"
              >
                <div slot="actions" slot-scope="{ puzzleId, puzzleName }">
                  <d-link
                    :to="{
                      name: 'admin-letrex-edit',
                      params: { puzzleId },
                    }"
                  >
                    {{ puzzleName }}
                  </d-link>
                </div>
              </puzzle-list-table>
            </div>
            <pagination
              :total-items="puzzle.total_items"
              :pagination.sync="pagination"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import PuzzleListTable from '_shared/PuzzleListTable.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import { TYPE_SLUG } from '../components/LetrexModel';

export default {
  name: 'letrex-list',
  components: {
    Pagination,
    PuzzleListTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        slug: TYPE_SLUG,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    puzzle() {
      const { puzzleList } = this.$store.state.puzzle;
      if (puzzleList && puzzleList.list.length) {
        return puzzleList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['setToggle', 'getPuzzleList', 'activeAlert']),
    getList() {
      this.getPuzzleList(this.pagination);
    },
    handleSendBatch(payload) {
      PuzzleService.send(payload.ids)
        .then(() => {
          this.activeAlert({
            message: this.$t('letrex.alert.sendSuccess'),
            theme: 'success',
          });
        })
        .catch(() => {
          this.activeAlert({
            message: this.$t('letrex.alert.sendError'),
            theme: 'danger',
          });
        });
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>
